exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".edit-sub-choose-date .choose-wrap[data-v-448df2ef] {\n  padding-bottom: 1em;\n}\n.edit-sub-choose-date .choose-wrap > p[data-v-448df2ef] {\n  padding: 0.5em 0 1em;\n}\n", ""]);

// exports
